import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { updateSlug } from '../member/thunk';

export type State = {
  baseUrl: string;
  enabledSocialConnections: string[];
  showPublicSections: boolean;
  isAboutInstalled: boolean;
  memberProfileURL: string;
};

export const siteSlice = createSlice({
  name: 'site',
  initialState: {
    baseUrl: '',
    isSSOMandatory: false,
    enabledSocialConnections: [] as string[],
    showPublicSections: false,
    isAboutInstalled: false,
    memberProfileURL: '',
  },
  reducers: {
    setBaseUrl(state, { payload }: PayloadAction<string>) {
      state.baseUrl = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateSlug.fulfilled, (state, { payload }) => {
      state.memberProfileURL = state.memberProfileURL.replace(
        payload.oldSlug,
        payload.newSlug,
      );
    });
  },
});
